module.exports = __webpack_public_path__ + "img/manage-data-2.e38274f0.jpg";